// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubMenu_wrapper__1ml3f","list":"SubMenu_list__2o3x6","button":"SubMenu_button__32X2E","text":"SubMenu_text__2NEO4","icon":"SubMenu_icon__k5K6h"};